/* eslint-disable no-unused-vars */

import _ from 'lodash';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import DataSnippets from '@components/data-snippet';
import TaskTally from '@components/task-tally';
import Icon from '@components/icon-component';
import InfoPopup from '@components/info-popup/info-popup.component';
import SiteInnerCard from '@components/equipment-card/site-inner-card';
import OpenLink from '@components/task-card-new/card-asset/open-link';

import { getAppDispatch } from '@utilities/dispatch.util';
import { formWrapperActions } from '@redux/slices/form-wrapper';
import { useOpenLink } from '@hooks/useOpenLink';

import style from './site-card.module.scss';

const StructureCard = (props) => {
  const [searchParams] = useSearchParams();
  const [desktopLink, setDesktopLink] = useState(null);
  const [openLink, setOpenLink] = useOpenLink({
    taskId: props?.structureId || '',
    assetId: props?.structureId || ''
  });
  const bookmarkId = searchParams.get('bookmarkId');

  const dispatch = getAppDispatch?.();

  const {
    onClickLink,
    to,
    title,
    subtitle,
    dataPoints,
    highlight,
    highlightName,
    equipments,
    open,
    setOpen,
    allTasksForSite,
    allDoneTasks,
    isOverDue,
    status,
    sites,
    moreInfo,
    showChevronIcon,
    noIcon = false,
    appliesTo = false,
    structureDetails = false,
    structureListing = false,
    link,
    noLink,
    addNewWizard,
    structureId,
    siteDataPoints = [],
    onInfoCLick,
    onBookmarkCLick,
    infoTabActive,
    toDesktopLink,
    otherTabsView
  } = props;
  let [highlightNames, highlightType] = !_.isEmpty(highlight) ? highlight.split(' ') : [];
  highlightNames = highlightName ? highlight : highlightNames;

  if (!highlightType) highlightType = highlightNames;

  const onClickOpliiDesktopLinkEvent = (desktopLink) => {
    setDesktopLink({ linkValue: desktopLink });
    setOpenLink((prev) => !prev);

    dispatch?.(
      formWrapperActions.checkTheLinkIsOpen({
        taskId: structureId,
        assetId: structureId
      })
    );
  };

  const equipmentInfo = () => {
    return (
      <div className={style.cardInner}>
        <div className={style.cardContent}>
          <div
            style={{
              position: 'relative'
            }}
          >
            <DataSnippets
              title={title || ''}
              link={link}
              subtitle={subtitle || ''}
              dataPoints={dataPoints}
              iconName={noIcon || structureDetails || appliesTo ? '' : 'home-icon'}
              highlightNames={highlightNames}
              highlightType={highlightType}
              className={`${style.marginClass} ${structureListing && style.paddingOnListingPage} ${
                style['mb-4']
              }`}
              onClickOpliiDesktopLinkEvent={onClickOpliiDesktopLinkEvent}
              toDesktopLink={toDesktopLink}
              inDetailView={!showChevronIcon && !appliesTo}
            />

            <OpenLink
              openLink={openLink}
              desktopLink={desktopLink}
              setOpenLink={setOpenLink}
              setDesktopLink={setDesktopLink}
              selectedLinkTypeIcon={'home-icon'}
              selectedLinkTypeName={'structure'}
            />
          </div>

          <div
            className={`${style.chipsDiv} ${_.isEmpty(sites) && !appliesTo && style['mb-0']} `}
            style={{
              padding: structureDetails || noIcon || appliesTo ? '0px' : '0px 20px 0px 60px',
              marginBottom: '0px'
            }}
          >
            {status && (
              <>
                <TaskTally statusText={status || ''} />
              </>
            )}
            {equipments?.length > 0 && (
              <>
                <TaskTally
                  width={'14px'}
                  height={'16px'}
                  iconName={'equipment'}
                  statusText={equipments.length || ''}
                />
              </>
            )}
          </div>

          <div
            className={`${style.chipsDiv} ${_.isEmpty(sites) && !appliesTo && style['mb-0']} `}
            style={{
              padding: structureDetails || noIcon || appliesTo ? '0px' : '0px 20px 0px 60px',
              // marginTop: '6px',
              position: 'relative'
            }}
          >
            {allTasksForSite?.length > 0 && (
              <TaskTally
                status={
                  allDoneTasks.length === 0
                    ? 'overdue'
                    : allDoneTasks.length > 0 && allTasksForSite.length > allDoneTasks.length
                    ? 'inProgress'
                    : allDoneTasks.length === allTasksForSite.length
                    ? 'done'
                    : ''
                }
                statusText={`${allDoneTasks.length}/${allTasksForSite.length}`}
                dot={!!isOverDue && 'true'}
                iconName={'task-bag-icon'}
              />
            )}

            {props?.allOnDemandRecordCount > 0 && (
              <TaskTally
                statusText={`${props?.allOnDemandRecordCount}`}
                width={14}
                height={16}
                iconName={'on-demand-indicator'}
                allOnDemandRecordCount
              />
            )}
            {!showChevronIcon &&
              !appliesTo &&
              !otherTabsView &&
              (infoTabActive ? (
                <div className={`${style.infoIcon} ${style.infoTabActive}`}>
                  <Icon name="info-disabled" height={24} width={24} />
                </div>
              ) : (
                <div className={`${style.infoIcon}`} onClick={onInfoCLick}>
                  <Icon name="info-icon-blue-stroke" height={24} width={24} />
                </div>
              ))}
          </div>

          {!_.isEmpty(sites) && (
            <SiteInnerCard
              sites={{
                ...sites,
                link: !addNewWizard ? (!noLink ? `/site-details/${sites?.siteId}` : '') : null,
                highlight,
                highlightName,
                hideLocation: structureDetails || appliesTo,
                structureListing,
                siteDataPoints,
                addNewWizard
              }}
              appliesTo={appliesTo}
              taskId={structureId}
              assetId={sites?.siteId}
            />
          )}
        </div>

        {showChevronIcon && !appliesTo ? (
          <div>
            <div>
              <Icon name={'chevron-right'} width="10px" />
            </div>
          </div>
        ) : !appliesTo ? (
          <div>
            {!otherTabsView && (
              <div className={style.bookmarkIcon}>
                {bookmarkId ? (
                  <Icon name={'bookmarked-name'} height={24} width={24} onClick={onBookmarkCLick} />
                ) : (
                  <Icon name={'bookmark-blue'} height={24} width={24} onClick={onBookmarkCLick} />
                )}
              </div>
            )}
          </div>
        ) : (
          ''
        )}
      </div>
    );
  };

  return structureDetails || appliesTo ? (
    <div
      className={`${style.cardWrapperNoHover} ${props?.className}`}
      style={{
        padding: structureDetails || appliesTo ? '16px' : '',
        border: '0.5px solid #cbd2d9'
      }}
    >
      {equipmentInfo()}
    </div>
  ) : (
    <div
      className={`${style.cardWrapper}`}
      style={{
        cursor: 'pointer'
      }}
      onClick={onClickLink}
    >
      {equipmentInfo()}
    </div>
  );
};

export default StructureCard;
